var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderMember',{attrs:{"header":"แก้ไขข้อมูลพนักงาน","img_header":_vm.header_image,"link_back":"admin"}}),_c('EditEmployee')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }